/* Project Import will be here */
import { getErrorObject, errorToast, successToast, getResObj } from "utilities/utils";
import { getProfileApi, getProfileAddress, addOrEditRetailerAddressApi, deleteRetailerAddressApi } from "services/profile";
import { IRetailerAddr, IRetailerAddrRequestParams, IDeleteAddrRequestParams } from "models/profileModels";
import { getRetailerOutstandingAmountApi } from "services/cart";
import { showMsgFromJson } from "reducers/common";
import Constants from "../utilities/appConstants";
/* Project Import will be here */

export const types = {
  LOAD_PROFILE_REQUEST: "profile/LOAD_PROFILE_REQUEST",
  LOAD_PROFILE_SUCCESS: "profile/LOAD_PROFILE_SUCCESS",
  LOAD_PROFILE_FAILURE: "profile/LOAD_PROFILE_FAILURE",
  SUBMIT_PROFILE_REQUEST: "profile/SUBMIT_PROFILE_REQUEST",
  SUBMIT_PROFILE_SUCCESS: "profile/SUBMIT_PROFILE_SUCCESS",
  SUBMIT_PROFILE_FAILURE: "profile/SUBMIT_PROFILE_FAILURE",
  LOAD_PROFILE_ADDRESS_REQUEST: "profile/LOAD_PROFILE_ADDRESS_REQUEST",
  LOAD_PROFILE_ADDRESS_SUCCESS: "profile/LOAD_PROFILE_ADDRESS_SUCCESS",
  LOAD_PROFILE_ADDRESS_FAILURE: "profile/LOAD_PROFILE_ADDRESS_FAILURE",
  UPDATE_RETAILER_OUTSTANDING_AMOUNT: "profile/UPDATE_RETAILER_OUTSTANDING_AMOUNT",
  ADD_EDIT_DELETE_ADDRESS_REQUEST: "profile/AddEditDeleteAddressRequest",
  ADD_EDIT_DELETE_ADDRESS_RESPONSE: "profile/AddEditDeleteAddressResponse",
  ADD_EDIT_DELETE_ADDRESS_FAILURE: "profile/AddEditDeleteAddressFailure",
};

const initialState = {
  isLoading: false,
  error: null,
  address: [],
  form: {
    isLoading: false,
    error: null,
    data: {}
  },
  retailerOutstandingAmount: 0
};

export const profile = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_PROFILE_REQUEST: {
      return { ...state, form: { ...state.form, isLoading: true } };
    }

    case types.LOAD_PROFILE_SUCCESS: {
      const { data } = action.payload;
      return { ...state, form: { ...state.form, isLoading: false, data } };
    }

    case types.LOAD_PROFILE_FAILURE: {
      const { error } = action.payload;
      return { ...state, form: { ...state.form, isLoading: false, error } };
    }

    case types.LOAD_PROFILE_ADDRESS_REQUEST: {
      return { ...state, isLoading: true };
    }

    case types.LOAD_PROFILE_ADDRESS_SUCCESS: {
      const { address } = action.payload;
      return { ...state, isLoading: false, address: address };
    }

    case types.LOAD_PROFILE_ADDRESS_FAILURE: {
      const { error } = action.payload;
      return { ...state, isLoading: false, error };
    }

    case types.SUBMIT_PROFILE_REQUEST: {
      return { ...state, isLoading: true };
    }
    case types.SUBMIT_PROFILE_SUCCESS: {
      return { ...state, isLoading: false };
    }

    case types.UPDATE_RETAILER_OUTSTANDING_AMOUNT: {
      return { ...state, retailerOutstandingAmount: action.payload.outstandingAmount };
    }

    case types.SUBMIT_PROFILE_FAILURE: {
      const { error } = action.payload;
      return { ...state, isLoading: false, error };
    }

    case types.ADD_EDIT_DELETE_ADDRESS_REQUEST: {
      return { ...state, isLoading: true };
    }

    case types.ADD_EDIT_DELETE_ADDRESS_RESPONSE: {
      return { ...state, isLoading: false };
    }

    case types.ADD_EDIT_DELETE_ADDRESS_FAILURE: {
      const { error } = action.payload;
      return { ...state, isLoading: false, error };
    }
    
    default:
      return state;
  }
};

export const loadProfile = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOAD_PROFILE_REQUEST });
    try {
      const response = await getProfileApi();
      const data = getResObj(response.data.Data);
      dispatch({ type: types.LOAD_PROFILE_SUCCESS, payload: { data } });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.LOAD_PROFILE_FAILURE));
    }
  };
};

export const loadProfileData = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOAD_PROFILE_REQUEST });
    try {
      const response = await getProfileApi();
      const data = getResObj(response.data.Data);
      dispatch({ type: types.LOAD_PROFILE_SUCCESS, payload: { data } });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.LOAD_PROFILE_FAILURE));
    }
  };
};

export const loadProfileAddressData = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOAD_PROFILE_ADDRESS_REQUEST });
    try {
      /* Get retailer address list from server */
      const response = await getProfileAddress();
      const responseObj = getResObj(response.data.Data);

      /* Check for address undefined issue */
      const address = (responseObj !== undefined) ? responseObj : [];

      dispatch({ type: types.LOAD_PROFILE_ADDRESS_SUCCESS, payload: { address } });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.LOAD_PROFILE_ADDRESS_FAILURE));
    }
  };
};

/* Get the retailer outstanding amount when the page is loading */
export const getRetailerOutstandingAmount = () => {
  return async (dispatch, getState) => {
    try {
      const response = await getRetailerOutstandingAmountApi();
      dispatch({ type: types.UPDATE_RETAILER_OUTSTANDING_AMOUNT, payload: { outstandingAmount: response.data.Data[0].osamount } });
    } catch (error) {
      dispatch({ type: types.UPDATE_RETAILER_OUTSTANDING_AMOUNT, payload: { outstandingAmount: 0 } });
    }
  };
}

/* Add new retailer address */
export const addOrEditRetailerAddress = (data: IRetailerAddr, addr = null) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.ADD_EDIT_DELETE_ADDRESS_REQUEST });
    try {
      const requestParams: IRetailerAddrRequestParams = {
        RetAddress_Id: addr === null ? 0 : addr.AddressID,
        Address1: data.Address,
        AddressID: 0,
        City: data.City,
        Country: data.Country,
        isAddressSelected: false,
        Default: addr === null ? 0 : (addr.Default ? 1 : 0),
        MobileNo: data.Mobile,
        State: data.State,
        Zip: data.Pincode
      };

      /* Make API call to save the new retailer address */
      const response = await addOrEditRetailerAddressApi(requestParams);

      dispatch({ type: types.ADD_EDIT_DELETE_ADDRESS_RESPONSE });

      /* Show success message */
      successToast({ content: response.data.Msg });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ADD_EDIT_DELETE_ADDRESS_FAILURE));
    }
  };
}

/* Delete existing retailer address */
export const deleteRetailerAddress = (addressId) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.ADD_EDIT_DELETE_ADDRESS_REQUEST });
    try {
      const requestParams: IDeleteAddrRequestParams = {
        RetAddress_Id: addressId
      };

      /* Make API call to save the new retailer address */
      const response = await deleteRetailerAddressApi(requestParams);

      dispatch({ type: types.ADD_EDIT_DELETE_ADDRESS_RESPONSE });

      /* Show success message */
      successToast({ content: response.data.Msg });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ADD_EDIT_DELETE_ADDRESS_FAILURE));
    }
  };
}

const promiseCatchBlock = (error: any, type: string) => {
  return (dispatch) => {
    /* Extract the error message and error code from the response object */
    const { message, errorCode } = getErrorObject(error);

    dispatch({
      type: type,
      payload: { error: message }
    });

    /* If error code is exist show the error code message or show the error message returned by the API request */
    if (errorCode !== "")
      dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
    else
      errorToast({ content: message });
  }
};